export function compare(a, b, name) {
  if (a[name]?.toLowerCase() < b[name]?.toLowerCase()) return -1;
  if (a[name]?.toLowerCase() > b[name]?.toLowerCase()) return 1;
  return 0;
}

export const sortArrOfData = (arr, keyToSortBy) => {
  return arr?.slice().sort((a, b) => compare(a, b, keyToSortBy));
};
